function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M24 8h2a2 2 0 012 2v3H4v-3c0-1.1.9-2 2-2h2c-.16-.38-.25-.8-.25-1.23 0-2.17 2.2-3.73 4.75-3.73 1.34 0 2.6.85 3.5 1.98.9-1.13 2.16-1.98 3.5-1.98 2.55 0 4.75 1.56 4.75 3.73 0 .44-.09.85-.25 1.23zm-11 7v9l3-1.97L19 24v-9h7v11a2 2 0 01-2 2H8a2 2 0 01-2-2V15h7zm-.5-9.46c-1.32 0-2.25.66-2.25 1.23S11.18 8 12.5 8c.3 0 .55 0 1 .02.66.03 1.01.03 1.23 0-.15-1.01-1.35-2.48-2.23-2.48zm6 2.48l1-.02c1.32 0 2.25-.66 2.25-1.23s-.93-1.23-2.25-1.23c-.88 0-2.08 1.47-2.23 2.49.22.02.57.02 1.23 0z",
  fill: "currentColor",
  fillRule: "evenodd"
});
function SvgGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _ref);
}
export default SvgGift;